import {
  useLocalStorage as useBaseLocalStorage,
  UseLocalStorageOptions,
} from '@mint-lib/hooks';
import { useProfile } from '@mint-lib/profile-helpers';

import { useDataFileRouteApi } from './useImportHubRouteApi.js';

export const useDataFileLocalStorage = <T>(
  key = '',
  options?: UseLocalStorageOptions<T>,
) => {
  const dataFileLocalStorageKey = useDataFileLocalStorageKey();

  const resultKey = key
    ? (`${dataFileLocalStorageKey}.${key}` as const)
    : dataFileLocalStorageKey;

  return useBaseLocalStorage(resultKey, options);
};

export const useDataFileLocalStorageKey = () => {
  const { profile } = useProfile();
  const { dataFileId } = useDataFileRouteApi().useParams();

  return `@myn/import-hub.users.${profile?.id}.dataFiles.${dataFileId}` as const;
};
